<template>
	<div class="percent-progress">
		<slot>
			<div v-if="header" class="percent-progress__header">
				{{ header }}
			</div>
			<div v-if="header" class="percent-progress__mobile-header">
				{{ mobileHeader }}
			</div>
		</slot>
		<div class="percent-progress__bar">
			<div :style="progressStyle" class="percent-progress__indicator"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PercentProgress",
	props: {
		progress: {
			type: String,
			default: "0",
		},
		header: {
			type: String,
			default: "",
		},
		mobileHeader: {
			type: String,
			default: "",
		},
	},
	computed: {
		progressStyle() {
			return `width: ${ this.progress }%`;
		},
	},
};
</script>

<style lang="scss" scoped>
.percent-progress__header,
.percent-progress__mobile-header {
	color: $onboardingStep-font-color;
	font-weight: 600;
	margin-bottom: .5rem;
	display: none;
}

.percent-progress__header {
	display: none;

	@include for-size('lg') {
		display: block;
	}
}

.percent-progress__mobile-header {
	display: block;

	@include for-size('lg') {
		display: none;
	}
}

.percent-progress__bar {
	background: $percentProgress-default-bg-color;
	border-radius: .25rem;
	width: 100%;
	height: 1rem;
}

.percent-progress__indicator {
	background: $percentProgress-default-indicator-color;
	height: 1rem;
	border-radius: .25rem;
}
</style>
